<template lang="pug">
  div.live-card-container(@click="handleClick")
    div.cover
      img.cover-img(:src="cover")
    div.info-item
      span.live-title {{ $t('live') }}
      span {{ roomName }}
</template>

<script>
export default {
  name: 'live-card',
  props: {
    roomInfo: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    cover() {
      return this.roomInfo.cover;
    },
    roomName() {
      return this.roomInfo.title;
    },
    userNumber() {
      return this.roomInfo.nnUsers;
    },
  },
  data() {
    return {
    };
  },
  methods: {
    handleClick() {
      this.$emit('chooseRoom');
    },
  },
};
</script>

<style lang="stylus" scoped>
.live-card-container
  width 320px
  cursor pointer
  margin 0 20px 30px
  .cover
    width 100%
    height 200px
    border-radius 4px 4px 0 0
    overflow hidden
    .cover-img
      width 100%
      height 100%
  .info-item
    width 100%
    height 40px
    border-radius 0 0 4px 4px
    display flex
    align-items center
    background-color #FFFFFF
    padding 2px 6px
</style>

<i18n>
{
	"en": {
		"live": "【Live】"
	},
	"zh": {
		"live": "【直播】"
	}
}
</i18n>
